import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/documents/$templateId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$dealership/deal-packets/templates/$templateId",
      params,
    })
  },
})
